export const ORDER_LIST_FLAG = 'refactor18-orderlist'

export const ASSORTMENT_REVIEW_RECEIPT_MONTH =
  'dev-assortment-review-receipt-month'
export const BRAND_DASHBOARD = 'brand-dashboard'

export const BRAND_PAYMENTS_SETTINGS = 'brand-payments-settings'

export const SELF_SERVE_PERMISSIONING = 'self-serve-permissioning'
export const ENABLE_MANAGE_PERMISSIONS = 'new-permissions-page'
export const RETAIL_INTEGRATION_SETTINGS = 'retail-integration-settings'

export const SSO_SETTINGS = 'sso-management'

export const BRAND_REPORTING = 'brand-reporting'
export const REPORTING_CONFIGURATIONS = 'reporting-configurations'

export const VIRTUAL_SHOWROOM = 'virtual-showroom'

export const VNTANA = 'vntana'

export const NEW_CONNECTIONS_UI = 'new-connections-ui'

export const BRAND_SUBMISSIONS_FLAG = 'brand-submissions-flag'

export const SWATCH_CREATION_AND_MANAGEMENT = 'swatch-creation-and-management'

export const SELF_SERVE_PREMIUM_FEATURES = 'self-serve-premium-features'

export const SELF_SERVE_USER_MANAGEMENT = 'self-serve-user-management'

export const REFACTOR_CHECKOUT_SHIPPING_BILLING =
  'refactor-checkout-shipping-billing'
